import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export type MetodoPagamento = "pix" | "boleto" | "cartao_credito" | "cartao_debito";

/**
 * Métodos que o servidor aceita para este Parceiro (Produção: só PIX). Falha fechado: carregando ou com erro, só PIX.
 * O servidor continua sendo a autoridade (409 METODO_PAGAMENTO_INDISPONIVEL); isto só evita oferecer o que será recusado.
 */
export function useMetodosPagamento(enabled = true): readonly MetodoPagamento[] {
  const { data } = useQuery<{ methods: MetodoPagamento[] }>({
    queryKey: ["asaas-metodos-pagamento"],
    queryFn: () => apiRequest("GET", "/api/asaas/metodos-pagamento").then((r) => r.json()),
    enabled,
    staleTime: 5 * 60_000,
  });
  return data?.methods ?? ["pix"];
}
